import '../styles/video-js.css'
import './replaceAssets.css'
import {
  findIntakeWithIdQuery_findIntakeWithId,
  GetOwnIntakeQuery,
  GetOwnIntakeQuery_getOwnIntake,
  UpdateOwnIntakeMutation_updateIntake,
} from '../schema/schemaTypes'
import {useMutation, useQuery} from '@apollo/client'
import { dynamicSurgeryTypeTexts } from '../organisms/Intakes/dynamicSurgeryTypeTexts'
import {intakeMetrics} from '../organisms/Intakes/intakeMetrics/calcIntakeMetrics'
import {UPDATE_OWN_INTAKE_MUTATION} from '../mutations/UPDATE_OWN_INTAKE_MUTATION'
import { GET_SITE_IMAGES_QUERY} from '../queries/GET_SITE_IMAGES_QUERY'
import { apolloClient } from '../utils/apolloClient'
import React, { useEffect, useState } from 'react'
import ReactHtmlParser from 'react-html-parser'
import { isMobile } from 'react-device-detect'
import Parser from 'html-react-parser'

let cloudinaryUrlPNG: string
let cloudinaryUrlJPG: string
if (window.innerWidth < 400) {
  cloudinaryUrlPNG = 'https://res.cloudinary.com/dvjhedt3c/image/fetch/w_600,c_scale,f_png/'
  cloudinaryUrlJPG = 'https://res.cloudinary.com/dvjhedt3c/image/fetch/w_800,c_scale,f_jpg/'
} else {
  cloudinaryUrlPNG = 'https://res.cloudinary.com/dvjhedt3c/image/fetch/f_png/'
  cloudinaryUrlJPG = 'https://res.cloudinary.com/dvjhedt3c/image/fetch/f_jpg/'
}

export default function renderSafeHTML(rawHTML: any, element = 'div') {
  return React.createElement(element, {
    dangerouslySetInnerHTML: {
      __html: rawHTML,
    },
  })
}

const operators = {
  '==='(a: any, b: any) {
    return a === b
  },
  '!=='(a: any, b: any) {
    return a !== b
  },
  'or'(a: any, b: any) {
    return a || b
  },
  'and'(a: any, b: any) {
    return a && b
  },
}


const accordionItemEndSearch = RegExp('\{\{/accordion item\}\}', 'gi')
const accordionItemEndReplace = `</div></div></div>`
const accordionSearch = RegExp('\{\{accordion\}\}', 'gi')
const accordionReplace = '<div id="accordion" class="accordion">'
const accordionEndSearch = RegExp('\{\{/accordion\}\}', 'gi')
const accordionEndReplace = '</div>'

const dynamicSurgeryTypeTextSearch = RegExp('\{\{dynamic surgery type text\}\}', 'gi')

const h1Search = RegExp('^# (.*)', 'gim')
const h1Replace = '<h1>$1</h1>'
const h2Search = RegExp('^## (.*)', 'gim')
const h2Replace = '<h2>$1</h2>'
const h3Search = RegExp('^### (.*)', 'gim')
const h3Replace = '<h3>$1</h3>'
const boldSearch = RegExp('\\*\\*(.*?)\\*\\*', 'gim')
const boldReplace = '<strong>$1</strong>'
const italicsSearch = RegExp('\\*(.*?)\\*', 'gim')
const italicsReplace = '<em>$1</em>'

const listSearch = RegExp('{{list}}', 'gi')
const listReplace = '<ul class="list">'
const listEndSearch = RegExp('{{/list}}', 'gi')
const listEndReplace = '</ul>'
const listItemSearch = RegExp('^[-\\*] (.*)', 'gim')
const listItemReplace = '<li class="list-item">$1</li>'


const tickSearch = RegExp('\{\{tick class="([^"]*)" (.*).*\}\}', 'gi')
const tickReplace = '<li class="list-item $1">$2</li>'

const religiousInfoSearch =RegExp('{{religiousInfo}}', 'gi')
const religiousInfoReplace = '<div class="flex-column"><div class="container flex-column" >\n<div class="row pt-4"><div class="col-lg-6 flex-column">{{s3image screenspiritual_ES.png}}</div> <div class="col-lg-6 flex-column"><br/> <h2>Referencia a los servicios espirituales del hospital</h2>Puede ser reconfortante practicar su fe en el hospital. Puede ser reconfortante hablar con un capellán del hospital. Esto puede ayudar a aliviar las preActividadessobre la cirugía de su hijo. Un capellán del hospital de niños del condado de Orange (CHOC) trabaja todos los días de la semana. Están disponibles durante las siguientes horas: <br/>\n{{list}}\n- 8:00 AM – 8:30 PM  De lunes a viernes<br/>\n- 8:30 AM – 5:00 PM  Sábado y domingo<br/>{{/list}}<p>Los capellanes de los hospitales pueden:</p>{{list}}<br/>\n- Libros religiosos \n- Una pequeña estatua religiosa\n- Estampas religiosas\n- Agua bendita\n- Un rosario{{/list}}\n\nHay un capellán específico para las emergencias. Se puede contactar con ellos a cualquier hora.\n\nPor favor, pregunte a su enfermera si desea visitar a un capellán. CHOC ofrece muchos servicios basados en la fe. Por favor llame al (714)-509-4381 para más información.\n\nCHOC tiene una sala de oración y meditación. Los padres pueden encontrar que una visita allí puede aliviar las preocupaciones sobre la cirugía de su hijo. Esta sala es un lugar tranquilo y sagrado. Está abierta para la oración y la reflexión. Esta sala está diseñada para personas de todas las creencias y tradiciones.  La sala de oración y meditación se encuentra en el segundo piso de la Torre Bill Holmes.\n\nCHOC celebra misa católica en el hospital. La misa se celebra los lunes y viernes a las 12:15 PM. La misa se celebra en la Sala de Oración y Meditación. La sala está ubicada en el 2do piso de la Torre Bill Holmes.\n</div></div><div class="row justify-content-center"><div class="col-lg-5 col-md-6  flex-column"></div></div></div>'

const startSection3 =RegExp('{{startSection3}}', 'gi')


const startSection4 =RegExp('{{startSection4}}', 'gi')
const completeSection4 =RegExp('{{completeSection4}}', 'gi')




export function replaceAssets (raw: string, intake: GetOwnIntakeQuery_getOwnIntake, patientIntake: findIntakeWithIdQuery_findIntakeWithId) {


const cloudinaryUrlNoScale = 'https://res.cloudinary.com/dvjhedt3c/image/fetch/'
const lang = process.env.REACT_APP_LANGUAGE === 'es' ? 'es' : 'en'

// tslint:disable:max-line-length object-literal-sort-keys
const imageSearch = RegExp('\{\{image ([^. ]+?)\.([^. ]+?)( .*?)?\}\}', 'gi')
const imageReplace = `<img $3 src="${cloudinaryUrlPNG}https://uci-images.s3-us-west-1.amazonaws.com/images/$1.$2" ` +
  `srcset="${cloudinaryUrlPNG}https://uci-images.s3-us-west-1.amazonaws.com/images/$1@2x.$2 2x" />`

const imageReplacePablo = `<img $3 src="https://uci-images.s3-us-west-1.amazonaws.com/images/pablo-assets/$1.$2" ` +
  `srcset="https://uci-images.s3-us-west-1.amazonaws.com/images/pablo-assets/$1@2x.$2 2x" />`

const s3imageSearch = RegExp('\{\{s3image ([^. ]+?)\.([^. ]+?)( .*?)?\}\}', 'gi')
const s3imageReplace = `<img $3 src="${cloudinaryUrlPNG}https://s3-us-west-1.amazonaws.com/uci-images/images/$1.$2" ` +
  `srcset="${cloudinaryUrlPNG}https://s3-us-west-1.amazonaws.com/uci-images/images/$1@2x.$2 2x" />`

const s3imageReplacePablo = `<img $3 src="${cloudinaryUrlPNG}https://s3-us-west-1.amazonaws.com/uci-images/images/pablo-assets/$1.$2" ` +
  `srcset="${cloudinaryUrlPNG}https://s3-us-west-1.amazonaws.com/uci-images/images/pablo-assets/$1@2x.$2 2x" />`

const ess3imageSearch = RegExp('\{\{ess3image ([^. ]+?)\.([^. ]+?)( .*?)?\}\}', 'gi')
const ess3imageReplace = `<img $3 src="${cloudinaryUrlPNG}https://s3-us-west-1.amazonaws.com/uci-images/images/$1_ES.$2" ` +
  `srcset="${cloudinaryUrlPNG}https://s3-us-west-1.amazonaws.com/uci-images/images/$1@2x_ES.$2 2x" />`

const ess3imageReplacePablo = `<img $3 src="${cloudinaryUrlPNG}https://s3-us-west-1.amazonaws.com/uci-images/images/pablo-assets/$1_ES.$2" ` +
  `srcset="${cloudinaryUrlPNG}https://s3-us-west-1.amazonaws.com/uci-images/images/pablo-assets/$1@2x_ES.$2 2x" />`

  const s3imagehdSearch = RegExp('\{\{s3imagehd ([^. ]+?)\.([^. ]+?)( .*?)?\}\}', 'gi')
const s3imagehdReplace = `<img $3 src="${cloudinaryUrlPNG}https://s3-us-west-1.amazonaws.com/uci-images/images${window.localStorage.getItem('userType') === 'PARENT_WEBTIPS_ES_EXTENSION' ? '/hd' : ''}/$1.$2" ` +
  `srcset="${cloudinaryUrlPNG}https://s3-us-west-1.amazonaws.com/uci-images/images${window.localStorage.getItem('userType') === 'PARENT_WEBTIPS_ES_EXTENSION' ? '/hd' : ''}/$1@2x.$2 2x" />`


const ess3imagehdSearch = RegExp('\{\{ess3imagehd ([^. ]+?)\.([^. ]+?)( .*?)?\}\}', 'gi')
const ess3imagehdReplace = `<img $3 src="${cloudinaryUrlPNG}https://s3-us-west-1.amazonaws.com/uci-images/images${window.localStorage.getItem('userType') === 'PARENT_WEBTIPS_ES_EXTENSION' ? '/hd' : ''}/$1${window.localStorage.getItem('userType') === 'PARENT_WEBTIPS_ES_EXTENSION' ? '' : '_ES'}.$2" ` +
  `srcset="${cloudinaryUrlPNG}https://s3-us-west-1.amazonaws.com/uci-images/images${window.localStorage.getItem('userType') === 'PARENT_WEBTIPS_ES_EXTENSION' ? '/hd' : ''}/$1@2x${window.localStorage.getItem('userType') === 'PARENT_WEBTIPS_ES_EXTENSION' ? '' : '_ES'}.$2 2x" />`

const headerSearch = RegExp('\{\{header ([^. ]*)\.([^ ]*).*title="([^"]*)".*\}\}', 'gi')
const headerReplace = `<div class="header" style="width: 100%"><img style="width: 100%" src="${cloudinaryUrlJPG}https://s3-us-west-1.amazonaws.com/uci-images/images/$1.$2" ` +
  `srcset="${cloudinaryUrlPNG}https://s3-us-west-1.amazonaws.com/uci-images/images/$1@2x.$2 2x" />` +
  '<div class="header-title">$3</div></div>'


const pdfMapUriSearch = RegExp('\{\{pdfMapUri\}\}', 'gi')

const headerHCPSearch = RegExp('\{\{headerhcp ([^. ]*)\.([^ ]*).*title="([^"]*)".*\}\}', 'gi')
const headerHCPReplace = `<div class="header" style="width: 100%;text-align: center;"><img style="width: 100%" src="${cloudinaryUrlJPG}https://s3-us-west-1.amazonaws.com/uci-images/images/$1.$2" ` +
  `srcset="${cloudinaryUrlJPG}https://s3-us-west-1.amazonaws.com/uci-images/images/$1@2x.$2 2x" />` +
  '<div class="header-title">$3</div></div>'


const headerFAQSearch = RegExp('\{\{headerfaq ([^. ]*)\.([^ ]*).*title="([^"]*)".*\}\}', 'gi')
const headerFAQReplace = `<div class="header" style="width: 100%;text-align: center;"><img style="width: 100%" src="${cloudinaryUrlJPG}https://s3-us-west-1.amazonaws.com/uci-images/images/$1.$2" ` +
  `srcset="${cloudinaryUrlJPG}https://s3-us-west-1.amazonaws.com/uci-images/images/$1@2x.$2 2x" />` +
  '<div class="header-title-faq">$3</div>' +
    `<div class="faqbtns"><button onClick="window.goTo(\'/contents/webtips-faq\')" class="faqbtn1">${lang === 'es' ? 'Utilizar L-WebTIPS' : 'Using Webtips'}</button><button class="faqbtn2" onClick="window.goTo(\'/contents/surgery-faq\')" >${lang === 'es' ? 'Más información sobre la cirugía' : 'More Information about Surgery'}</button></div></div>`


const navigationNurseSearch = RegExp('\{\{nurse\_navigation\}\}')
const navigationNurseReplace = () => {
  return '<div class="occupationNavBar">' +
  `<button class="navTitle" onClick="window.history.pushState({url: '/HCP3-patientInfo'},null, '/HCP3-patientInfo'); window.history.go(0);">Patient Info</button>` +
  `<button class="navTitle" ${window.location.pathname.includes('/contents/HCP3-1') ? 'style="color: #FC9426"' : ''} onClick="window.history.pushState({url: '/contents/HCP3-1'},null, '/contents/HCP3-1'); window.history.go(0);">Pre-op Anxiety</button>` +
  `<button class="navTitle" ${window.location.pathname.includes('/contents/HCP3-2') ? 'style="color: #FC9426"' : ''} onClick="window.history.pushState({url: '/contents/HCP3-2'},null, '/contents/HCP3-2'); window.history.go(0);">Parent Education</button>` +
  `<button class="navTitle" ${window.location.pathname.includes('/contents/HCP3-3') ? 'style="color: #FC9426"' : ''} onClick="window.history.pushState({url: '/contents/HCP3-3a'},null, '/contents/HCP3-3a'); window.history.go(0);">Parent Training</button>` +
  `<button class="navTitle" ${window.location.pathname.includes('/contents/HCP3-4') ? 'style="color: #FC9426"' : ''} onClick="window.history.pushState({url: '/contents/HCP3-4'},null, '/contents/HCP3-4'); window.history.go(0);">Model Behavior</button>` +
  `<button class="navTitle" ${window.location.pathname.includes('/contents/HCP3-5') ? 'style="color: #FC9426"' : ''} onClick="window.history.pushState({url: '/contents/HCP3-5'},null, '/contents/HCP3-5'); window.history.go(0);">Summary</button>` +
  '</div>'
}

const navigationAnesthesiologistSearch = RegExp('\{\{anesthesiologist\_navigation\}\}')
const navigationAnesthesiologistReplace = () => {
  return '<div class="occupationNavBar">' +
  `<button class="navTitle" onClick="window.history.pushState({url: '/HCP1-patientInfo'},null, '/HCP1-patientInfo'); window.history.go(0);">Patient Info</button>` +
  `<button class="navTitle" ${window.location.pathname.includes('/contents/HCP1-1') ? 'style="color: #FC9426"' : ''} onClick="window.history.pushState({url: '/contents/HCP1-1a'},null, '/contents/HCP1-1a'); window.history.go(0);">Desired Behaviors</button>` +
  `<button class="navTitle" ${window.location.pathname.includes('/contents/HCP1-2') ? 'style="color: #FC9426"' : ''} onClick="window.history.pushState({url: '/contents/HCP1-2'},null, '/contents/HCP1-2'); window.history.go(0);">Undesired Behaviors</button>` +
  `<button class="navTitle" ${window.location.pathname.includes('/contents/HCP1-3') ? 'style="color: #FC9426"' : ''} onClick="window.history.pushState({url: '/contents/HCP1-3'},null, '/contents/HCP1-3'); window.history.go(0);">Conditional Behaviors</button>` +
  `<button class="navTitle" ${window.location.pathname.includes('/contents/HCP1-4') ? 'style="color: #FC9426"' : ''} onClick="window.history.pushState({url: '/contents/HCP1-4'},null, '/contents/HCP1-4'); window.history.go(0);">Summary</button>` +
  '</div>'
}

const videoPreviewSearch = RegExp('\{\{videoPreview ([^. ]*)\.([^ ]*).*title="([^"]*)".*subtitle="([^"]*)".*video="([^"]*)".*videoDescription="([^"]*)".*\}\}', 'gi')
const videoPreviewReplace = `
<div style="display: flex;">
<div onClick="openPreview(this)" class="videoPreview" >
<img src="https://s3-us-west-1.amazonaws.com/uci-images/images${window.localStorage.getItem('userType') === 'PARENT_WEBTIPS_ES_EXTENSION' ? '/hd' : ''}/$1.$2"
  srcset="https://s3-us-west-1.amazonaws.com/uci-images/images${window.localStorage.getItem('userType') === 'PARENT_WEBTIPS_ES_EXTENSION' ? '/hd' : ''}/$1@2x.$2 2x" />
<img src="https://s3-us-west-1.amazonaws.com/uci-images/images/whitePlay.png"
class="whitePlay">
<div class="videoPreviewText">
  <span class="videoTitle" >$3</span>
  <span class="videoSubtitle">$4</span>
</div>
</div>
<div class="videoModal">
<div class="show-small flex-column">
<div class="videoModalRow">
    <div class="videoModalTitle">$3</div>
  <img
  onClick="closePreview(event, this); return true;"
  src="https://s3-us-west-1.amazonaws.com/uci-images/images/whiteClose.png" srcset="https://s3-us-west-1.amazonaws.com/uci-images/images/whiteClose@2x.png 2x" style="
    height: 20px;
    width: 20px;
" />
</div>

<video class="video-js vjs-4-3" controls preload="auto" width="640" height="264" title="$3" data-setup="{}"><source src="https://uci-images.s3-us-west-1.amazonaws.com/video${window.localStorage.getItem('userType') === 'PARENT_WEBTIPS_ES_EXTENSION' ? '/hd' : ''}/$5" type="video/mp4" /></video>

<div class="videoModalDescription">
$6
</div>
</div>

<div class="show-big flex-column">
<div class="videoContainer">
<div class="videoRow">
  <div class="videoCol">
    <div class="videoModalTitle2">$3</div>
    <div class="videoModalDescription2">
    $6
    </div>
  <img
  onClick="closePreview2(event, this); return true;"
  src="https://s3-us-west-1.amazonaws.com/uci-images/images/videoClose.png" srcset="https://s3-us-west-1.amazonaws.com/uci-images/images/videoClose@2x.png 2x" style="
    height: 36px;
    width: 86px;
    margin-top: 34px;
" />


  </div>
  <div class="videoCol" >
  <video class="video-js vjs-4-3" controls preload="auto" width="640" height="264" title="$3"
    data-setup="{}"><source src="https://uci-images.s3-us-west-1.amazonaws.com/video${window.localStorage.getItem('userType') === 'PARENT_WEBTIPS_ES_EXTENSION' ? '/hd' : ''}/$5" type="video/mp4" /></video>
  </div>
  </div>
</div>
</div>
</div>
</div>
`


const videoSearch = RegExp('\{\{video ([^.]+?)\.([^.]+?)\}\}', 'gi')
const movieSearch = RegExp('\{\{movie ([^.]+?)\.([^.]+?) title="([^"]*)".*\}\}', 'gi')
const videoReplace = '<div class="video-container">' +
  `<video id="my-video" title="$3" class="video-js vjs-4-3" poster="https://uci-images.s3-us-west-1.amazonaws.com/video${window.localStorage.getItem('userType') === 'PARENT_WEBTIPS_ES_EXTENSION' ? '/hd' : ''}/$1-preview%402x.png" controls preload="auto" width="640" height="264" ` +
  `data-setup="{}"><source src="https://uci-images.s3-us-west-1.amazonaws.com/video${window.localStorage.getItem('userType') === 'PARENT_WEBTIPS_ES_EXTENSION' ? '/hd' : ''}/$1.$2" type="video/$2"></video></div>`

const audioSearch = RegExp('\{\{audio ([^.]+?)\.([^.]+?)\}\}', 'gi')
const audioReplace = '<audio controls><source src="$1.$2" type="audio/$2"></audio>'

const tooltipSearch = RegExp('\{\{tooltip title="([^"]+?)" content="([^"]+?)"\}\}', 'gi')
const tooltipReplace = `<span class="tooltip-text" data-toggle="tooltip" data-placement="top" title="<h4>$1</h4>$2" ` +
  `>$1</span>`

const slideshowSearch = RegExp('\{\{slideshow\}\}', 'gi')
const slideshowReplace = '<div class="slideshow">'
const slideshowEndSearch = RegExp('\{\{/slideshow\}\}', 'gi')
const slideshowEndReplace = '</div>'


const slideshowWithButtonsSearch = RegExp('\{\{slideshowWithButtons\}\}', 'gi')
const slideshowWithButtonsReplace = '<div class="slideButtons">'
const slideshowWithButtonsEndSearch = RegExp('\{\{/slideshowWithButtons\}\}', 'gi')
const slideshowWithButtonsEndReplace = '<button class="slide-prev-btn" />' +
  '<button class="slide-next-btn" />' +
  '<button class="slide-prev-btn2" />' +
  '<button class="slide-next-btn2" />' +
  '</div>'


const tabSearch = RegExp('\{\{tab title="([^"]+?)"\}\}', 'gi')
const tabReplace = (no: number) => `<div class="tab-pane fade ${no === 0 ? 'show active' : ''}" ` +
  `id="assets-tab-${no}" role="tabpanel" aria-labelledby="assets-tab-${no}-tab">`
const tabTitleReplace = (title: string, no: number) => `<li class="nav-item">` +
  `<a class="nav-link active" id="assets-tab-${no}-tab" data-toggle="tab" href="#assets-tab-${no}" role="tab">` +
    `${title}</a></li>`
const tabEndSearch = RegExp('\{\{/tab\}\}', 'gi')
const tabEndReplace = '</div>'
const tabsSearch = RegExp('\{\{tabs\}\}', 'gi')
const tabsReplace = (titles: string[]) => `<ul class="nav nav-tabs tabs" role="tablist">` +
  titles.map(tabTitleReplace) + `</ul><div class="tab-content">`
const tabsEndSearch = RegExp('\{\{/tabs\}\}', 'gi')
const tabsEndReplace = '</div>'

const modalSearch = RegExp('\{\{modal ([^. ]+?)\.([^. ]+?)( .*?)?\}\}', 'gi')
const modalReplace = (no: number) =>
  `<button type="button"
  style="width:100%"
  onClick="console.log('open modal'); setTimeout(window.enableSlideshow2, 500)"
     class="no-btn" data-toggle="modal" data-target="#modal-${no}">` +
    `<img $3 src="${cloudinaryUrlPNG}https://uci-images.s3-us-west-1.amazonaws.com/images/$1.$2" srcset="${cloudinaryUrlPNG}https://uci-images.s3-us-west-1.amazonaws.com/images/$1@2x.$2 2x" />` +
  `</button>` +
  `<div class="modal fade" id="modal-${no}" tabindex="-1" role="dialog" aria-labelledby="modal-${no}-label" ` +
    `aria-hidden="true">` +
    `<div class="modal-dialog modal-lg" role="document">` +
      `<div class="modal-content">` +
        // `<div class="modal-header">` +
  // `<h5 class="modal-title" id="modal-${no}-label">Title</h5>` +
  // `</div>` +
        `<div class="modal-body">` +
          `<button type="button" class="close close-modal-btn" data-dismiss="modal" aria-label="Close">` +
            `<span aria-hidden="true">&times;</span>` +
          `</button>`

const modalReplacePablo = (no: number) =>
          `<button type="button"
          style="width:100%"
          onClick="console.log('open modal'); setTimeout(window.enableSlideshow2, 500)"
             class="no-btn" data-toggle="modal" data-target="#modal-${no}">` +
            `<img $3 src="${cloudinaryUrlPNG}https://uci-images.s3-us-west-1.amazonaws.com/images/pablo-assets/$1.$2" srcset="${cloudinaryUrlPNG}https://uci-images.s3-us-west-1.amazonaws.com/images/pablo-assets/$1@2x.$2 2x" />` +
          `</button>` +
          `<div class="modal fade" id="modal-${no}" tabindex="-1" role="dialog" aria-labelledby="modal-${no}-label" ` +
            `aria-hidden="true">` +
            `<div class="modal-dialog modal-lg" role="document">` +
              `<div class="modal-content">` +
                // `<div class="modal-header">` +
          // `<h5 class="modal-title" id="modal-${no}-label">Title</h5>` +
          // `</div>` +
                `<div class="modal-body">` +
                  `<button type="button" class="close close-modal-btn" data-dismiss="modal" aria-label="Close">` +
                    `<span aria-hidden="true">&times;</span>` +
                  `</button>`

const modalEndSearch = RegExp('\{\{/modal\}\}', 'gi')
const modalEndReplace =
        `</div>` +
        // `<div class="modal-footer">` +
        //   `<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>` +
        //   `<button type="button" class="btn btn-primary">Save changes</button>` +
        // `</div>` +
      `</div>` +
    `</div>` +
  `</div>`

const accordionItemSearch = RegExp('\{\{accordion item title="([^"]+?)"\}\}', 'gi')
const accordionItemSearchClosed = RegExp('\{\{accordion item title="([^"]+?)" closed\}\}', 'gi')
const accordionItemReplace = (title: string, no: number, closed:boolean = false) =>
  `<div class="card">` +
    `<div class="m-2 accordion-item-header" id="accordion-item-header-${no}">` +
      `<h5 class="mb-0">` +
        `<button class="btn ${no === 0 && !closed ? '' : 'collapsed'}" data-toggle="collapse" ` +
          `data-target="#accordion-item-${no}" aria-expanded="${no === 0 && !closed ? 'true' : 'false'}" ` +
`aria-controls="accordion-item-${no}">` +
          `<div class="accordion-item-title">` +
          title +
          `</div>` +
          `<div class="accordion-item-header-arrow"></div>` +
        `</button>` +
      `</h5>` +
    `</div>` +
    `` +
    `<div id="accordion-item-${no}" class="accordion-item collapse ${no === 0 && !closed ? 'show' : ''}" ` +
      `aria-labelledby="accordion-item-header-${no}" data-parent="#accordion">` +
      `<div class="card-body">`;


  (window as any).myRaw = raw.slice(0)

  const isPablo = intake.characterChoice === 'pablo'

  if(raw.search(startSection3) > 0){
    // Set startSection3 = true
    // @ts-ignore

    if(apolloClient) {
      const [addMutation, res] = useMutation(UPDATE_OWN_INTAKE_MUTATION, {client: apolloClient})
      addMutation({variables: {review2ImportantOneParentInLobby: '1'}}).then(r => console.log(r))
    }

    raw = raw.replace(startSection3, '')
  }

  if(raw.search(startSection4) > 0){
    // Set startSection3 = true
    // if(apolloClient && apolloClient !== undefined) {
      // const [addMutation] = useMutation(UPDATE_OWN_INTAKE_MUTATION)
      // addMutation({variables: {painMedsExpressCryingWhining: 1}}).then(r => console.log(r))
    // }

    raw = raw.replace(startSection4, '')
  }

  if(raw.search(completeSection4) > 0){
    // Set startSection3 = true
    if(apolloClient) {
      const [addMutation, res] = useMutation(UPDATE_OWN_INTAKE_MUTATION, {client: apolloClient})

      addMutation({variables: {review4AllTrueAboutManagingChildsPainAtHomeExcept: '1'}}).then(r => console.log(r))
    }
    raw = raw.replace(completeSection4, '')
  }


  if(raw.search(religiousInfoSearch) > -1){

    if(apolloClient) {
      const {loading, data, error} = useQuery(GET_SITE_IMAGES_QUERY, {client: apolloClient})
      if (data) {
        const text = ReactHtmlParser(data?.getSiteImages?.religiousText)[0].props.children[0]
        raw = raw.replace(religiousInfoSearch, '<div class="container flex-column" >\n<div class="row pt-4"><div class="col-lg-6 flex-column">{{s3image screenspiritual_ES.png}}</div> <div class="col-lg-6 flex-column"><div class="row justify-content-center"><div class="col-lg-12 col-md-12  flex-column">' + ReactHtmlParser(data?.getSiteImages?.religiousText)[0].props.children[0] + '</div></div></div>')
      }
    }
  }

  // {{image}}
  if(isPablo){

    raw = raw.replace(imageSearch, imageReplacePablo)
    raw = raw.replace(s3imageSearch, s3imageReplacePablo)
    raw = raw.replace(ess3imageSearch, ess3imageReplacePablo)
  }else{

    raw = raw.replace(imageSearch, imageReplace)
    raw = raw.replace(s3imageSearch, s3imageReplace)
    raw = raw.replace(ess3imageSearch, ess3imageReplace)
  }
  raw = raw.replace(ess3imagehdSearch, ess3imagehdReplace)
  raw = raw.replace(s3imagehdSearch, s3imagehdReplace)

  // {{header}}
  raw = raw.replace(headerSearch, headerReplace)
  raw = raw.replace(headerHCPSearch, headerHCPReplace)
  raw = raw.replace(headerFAQSearch, headerFAQReplace)

  raw = raw.replace(pdfMapUriSearch, (localStorage.getItem('pdfMapUri') || '').trim())

  raw = raw.replace(tickSearch, tickReplace)
  raw = raw.replace(videoPreviewSearch, videoPreviewReplace)

  // {{movie}} {{video}}
  raw = raw.replace(videoSearch, videoReplace)
  raw = raw.replace(movieSearch, videoReplace)

  // {{audio}}
  raw = raw.replace(audioSearch, audioReplace)

  // TODO: {{link}} {{goTo}}

  // {{tooltip}}
  raw = raw.replace(tooltipSearch, tooltipReplace)
  raw = raw.replace(`<h4>'induction of anesthesia'`, `<h4>induction of anesthesia`)

  // TODO: {{flash}}
  raw = raw.replace(slideshowSearch, slideshowReplace)
  raw = raw.replace(slideshowEndSearch, slideshowEndReplace)

  raw = raw.replace(slideshowWithButtonsSearch, slideshowWithButtonsReplace)
  raw = raw.replace(slideshowWithButtonsEndSearch, slideshowWithButtonsEndReplace)

  // {{tabs}} {{tab}}
  const tabTitles = []
  let tabTitleNo = 0
  let tabTitle
  // tslint:disable-next-line:no-conditional-assignment
  while ((tabTitle = tabSearch.exec(raw)) !== null) {
    tabTitles.push(tabTitle[1])
    raw = raw.replace(tabTitle[0], tabReplace(tabTitleNo))
    tabTitleNo++
  }
  raw = raw.replace(tabEndSearch, tabEndReplace)
  raw = raw.replace(tabsSearch, tabsReplace(tabTitles))
  raw = raw.replace(tabsEndSearch, tabsEndReplace)

  // {{accordion}}
  let accordionItemNo = 0
  let accordionItemTitle
  // tslint:disable-next-line:no-conditional-assignment
  while ((accordionItemTitle = accordionItemSearch.exec(raw)) !== null) {
    raw = raw.replace(accordionItemTitle[0], accordionItemReplace(accordionItemTitle[1], accordionItemNo))
    accordionItemNo++
  }
  // tslint:disable-next-line:no-conditional-assignment
  while ((accordionItemTitle = accordionItemSearchClosed.exec(raw)) !== null) {
    raw = raw.replace(accordionItemTitle[0], accordionItemReplace(accordionItemTitle[1], accordionItemNo, true))
    accordionItemNo++
  }
  raw = raw.replace(accordionItemEndSearch, accordionItemEndReplace)
  raw = raw.replace(accordionSearch, accordionReplace)
  raw = raw.replace(accordionEndSearch, accordionEndReplace)

  // {{modal}}
  if(isPablo){
    raw = raw.replace(modalSearch, modalReplacePablo(0))
  }else{
    raw = raw.replace(modalSearch, modalReplace(0))
  }
  
  raw = raw.replace(modalEndSearch, modalEndReplace)

  // TODO: {{questionaire}} {{questions}} {{dynamic-insert surgeryTight.php}}

  // TODO: {{faqs}} {{faq}}

  // TODO: {{include}}


  // {{nurse_navigation}}
  raw = raw.replace(navigationNurseSearch, navigationNurseReplace)

  // {{anesthesiologist_navigation}}
  raw = raw.replace(navigationAnesthesiologistSearch, navigationAnesthesiologistReplace)

  // {{if}}
  const executeElseStatements : boolean[] = []
  let countNumberIf = 0
  const intakeMetricsFunctions = intakeMetrics(intake)

  const patientIntakeMetricsFunctions = patientIntake ? intakeMetrics(patientIntake): {}

  const ifStatementSearch = RegExp('\{\{if ([^.]+?) (\=\=\=|\!\=\=) (.+?)( (and|or)? ([^.]+?)? (\=\=\=|\!\=\=)? (.+?)?)?\}\}', 'gi')
  const ifStatementReplace = (v1:any, v2: any, v3:any, v4:string, v5:string, v6: string, v7:string, v8:string, v9:string) => {
    const dotIndex = v4.indexOf('.')
    const bracketIndex = v4.indexOf('(')
    let value

    if (bracketIndex >= 0) {
      let functionName = v4.slice(dotIndex + 1, bracketIndex)
      const patientDotIndex = functionName.indexOf('.')
      if(patientDotIndex >= 0) {
        functionName = functionName.slice(patientDotIndex + 1)
        value = patientIntakeMetricsFunctions[functionName]
      } else {
        value = intakeMetricsFunctions[functionName]
      }
    } else {
      let fieldName = v4.slice(dotIndex + 1)
      const patientDotIndex = fieldName.indexOf('.')
      if(patientDotIndex >= 0) {
        fieldName = fieldName.slice(patientDotIndex + 1)
        value = patientIntake[fieldName]
      } else {
        value = intake[fieldName]
      }
    }
    if(v5) {
      const secondDotIndex = v9.indexOf('.')
      const secondBracketIndex = v9.indexOf('(')
      let secondValue

      if (secondBracketIndex >= 0) {
        let secondFunctionName = v9.slice(secondDotIndex + 1, secondBracketIndex)
        const secondPatientDotIndex = secondFunctionName.indexOf('.')
        if(secondPatientDotIndex >= 0) {
          secondFunctionName = secondFunctionName.slice(secondPatientDotIndex + 1)
          secondValue = patientIntakeMetricsFunctions[secondFunctionName]
        } else {
          secondValue = intakeMetricsFunctions[secondFunctionName]
        }
      } else {
        let secondFieldName = v9.slice(secondDotIndex + 1)
        const secondPatientDotIndex = secondFieldName.indexOf('.')
        if(secondPatientDotIndex >= 0) {
          secondFieldName = secondFieldName.slice(secondPatientDotIndex + 1)
          secondValue = patientIntake[secondFieldName]
        } else {
          secondValue = intake[secondFieldName]
        }
      }

      countNumberIf++
      /* tslint:disable */
      if(operators[v6](operators[v3](v2, value), operators[v8](v7, secondValue))) {
        executeElseStatements.push(false)
        return `<div style="display: flex">`
      } else {
        executeElseStatements.push(true)
        return `<div style="display: none">`
      }
    } else {
      countNumberIf++
      if(operators[v3](v2, value)) {
        executeElseStatements.push(false)
        return `<div style="display: flex">`
      } else {
        executeElseStatements.push(true)
        return `<div style="display: none">`
      }
    }
  }

  const elseStatementSearch = RegExp('\{\{else\}\}', 'gi')
  const elseStatementReplace = () => {
    --countNumberIf
    if(executeElseStatements[countNumberIf]) {
      return `</div><div>`
    } else {
      return `</div><div style="display: none">`
    }
  }

  const ifStatementEndSearch = RegExp('\{\{/if\}\}', 'gi')
  const ifStatementEndReplace= '</div>'

  raw = raw.replace(ifStatementSearch, ifStatementReplace)
  raw = raw.replace(elseStatementSearch, elseStatementReplace)
  raw = raw.replace(ifStatementEndSearch, ifStatementEndReplace)

  raw = raw.replace(h1Search, h1Replace)
  raw = raw.replace(h2Search, h2Replace)
  raw = raw.replace(h3Search, h3Replace)
  raw = raw.replace(boldSearch, boldReplace)
  raw = raw.replace(italicsSearch, italicsReplace)

  raw = raw.replace(listSearch, listReplace)
  raw = raw.replace(listEndSearch, listEndReplace)
  raw = raw.replace(listItemSearch, listItemReplace)

  raw = raw.replace(dynamicSurgeryTypeTextSearch, dynamicSurgeryTypeTexts[intake.surgeryType || ''])

  raw = raw.replace(/&#8232;/g,' ')
  raw = raw.replace(/\u2028/g,' ')

  return raw
}



// WEBPACK FOOTER //
// ./src/utils/replaceAssets.ts